import { render, staticRenderFns } from "./issueItem.vue?vue&type=template&id=2e1c435c&functional=true&"
import script from "./issueItem.vue?vue&type=script&lang=ts&"
export * from "./issueItem.vue?vue&type=script&lang=ts&"
import style0 from "./issueItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports